module.exports = __webpack_public_path__ + "static/media/wellness.56a6d5d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/wellness.jpg
// module id = 639
// module chunks = 11